export default {
  // 重试操作
  retry: lang.templateByUuid("UID:P_UDHWN_17DD50DE050006B5","重试") /* "重试" */,
  item: lang.templateByUuid("UID:P_UDHWN_17DD50DE050006B6","条") /* "条" */,
  handleBatchOperationWarning: lang.templateByUuid("UID:P_UDHWN_17DD50DE050006B7","请选择至少一条需要操作的信息") /* "请选择至少一条需要操作的信息" */
};
